module.exports = __webpack_public_path__ + "static/media/multigenerational.7e192d81.jpg";